module.exports = __webpack_public_path__ + "static/eti2-a64179ddfa25c1b6e665641f493e406b.png";